import React from 'react';
import { Modal, Form, Input, Select } from 'antd';

const { Option } = Select;

const ViewBug = ({ visible, onClose, bug }) => {
  return (
    <Modal
      title="Visualizar Bug"
      visible={visible}
      onCancel={onClose}
      footer={null}
    >
      <Form
        layout="vertical"
        initialValues={bug}
      >
        <Form.Item
          name="descricao"
          label="Descrição"
        >
          <Input.TextArea disabled />
        </Form.Item>
        <Form.Item
          name="tipo"
          label="Tipo"
        >
          <Select disabled>
            <Option value="Erro">Erro</Option>
            <Option value="Melhoria">Melhoria</Option>
            <Option value="Nova Funcionalidade">Nova Funcionalidade</Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ViewBug;
